import EndpointsBaseClass from "apiConsumers/EndpointsBaseClass";
import IMediaPageVideos from "./models/mediaPage/IMediaPageVideos";
import convertMediapageVideosResponse from "./converters/mediaPage/convertMediapageVideosResponse";
import IMediaPageScreenshots from "./models/mediaPage/IMediaPageScreenshots";
import convertMediapageScreenshotsResponse from "./converters/mediaPage/convertMediapageScreenshotsResponse";
import IQuote from "./models/quotes/IQuote";
import convertQuoteResponse from "./converters/quotes/convertQuoteResponse";

export default class KenticoApiConsumer extends EndpointsBaseClass {
    public async getMediaPageVideos(): Promise<IMediaPageVideos | undefined> {
        try {
            const response = await this.makeGetRequest(`/website/media_videos`);

            return convertMediapageVideosResponse(response);
        } catch (error) {
            return undefined;
        }
    }

    public async getMediaPageScreenshots(): Promise<IMediaPageScreenshots | undefined> {
        try {
            const response = await this.makeGetRequest(`/website/media_screenshots`);

            return convertMediapageScreenshotsResponse(response);
        } catch (error) {
            return undefined;
        }
    }

    public async getQuotes(): Promise<IQuote[] | undefined> {
        try {
            const response = await this.makeGetRequest(`/website/homepage_quotes`);

            return convertQuoteResponse(response);
        } catch (error) {
            return undefined;
        }
    }
}
